export const isDarkMode = () => {
  const elem = document.getElementById("norne_frame");
  if (elem) {
    //iframe
    return false;
  }

  return document.documentElement.classList.contains("dark");
};
